import React, { Component } from 'react';
import { Grid, Row, Col, Button } from 'react-bootstrap';

import Card from 'components/Card/Card.jsx';

import Form from 'react-jsonschema-form';
import SweetAlert from 'react-bootstrap-sweetalert';

//Redux
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as FranchisesActions from './redux/FranchisesActions';
import widgets from '../../lib/widgets';
import fields from '../../lib/fields';

import auth from '../../libCustom/auth';

const schema = {
  $id: 'http://example.com/example.json',
  type: 'object',
  definitions: {},
  $schema: 'http://json-schema.org/draft-07/schema#',
  required: [
    'name',
    'owner',
    'businessName',
    'rfc',
    'privateId',
    'phone',
    'email',
  ],
  properties: {
    hideOrders: {
      $id: '/properties/hideOrders',
      type: 'boolean',
      title: 'Ocultar Ventas NO Facturables',
      default: false,
      examples: [true],
    },
    hideOnWebsite: {
      $id: '/properties/hideOnWebsite',
      type: 'boolean',
      title: 'Ocultar Franquicia en Página Web',
      default: false,
      examples: [true],
    },
    skipPriceValidation: {
      $id: '/properties/skipPriceValidation',
      type: 'boolean',
      title: 'Excluir Validación de Precios y Comisiones',
      default: false,
      examples: [true],
    },
    name: {
      $id: '/properties/name',
      type: 'string',
      title: 'Nombre de Franquicia',
      default: '',
      examples: ['Centro'],
    },
    owner: {
      $id: '/properties/owner',
      type: 'string',
      title: 'Nombre de propietario',
      default: '',
      examples: ['Mario Rodríguez Torres'],
    },
    businessName: {
      $id: '/properties/businessName',
      type: 'string',
      title: 'Razón Social',
      default: '',
    },
    countablePerson: {
      $id: '/properties/countablePerson',
      type: 'string',
      title: 'Tipo de persona contable',
      default: 'fisica',
      enum: ['fisica', 'moral'],
      enumNames: ['Fisica', 'Moral'],
    },
    rfc: {
      $id: '/properties/rfc',
      type: 'string',
      title: 'RFC',
      default: '',
    },
    turistId: {
      $id: '/properties/turistId',
      type: 'number',
      title: 'Cédula Turistica',
      default: '',
      examples: [''],
    },
    privateId: {
      $id: '/properties/privateId',
      type: 'number',
      title: 'Clave Privada',
      default: '',
      examples: ['1'],
    },
    phone: {
      $id: '/properties/phone',
      type: 'string',
      title: 'Teléfono principal',
      default: '',
      examples: [' 44 34 54 32 35'],
    },
    businessHours: {
      $id: '/properties/businessHours',
      type: 'array',
      title: 'Horarios de atención',
      default: [
        {
          days: 'Lunes a Viernes',
          startTime: '09:00',
          endTime: '19:00'
        },
        {
          days: 'Sábados',
          startTime: '10:00',
          endTime: '14:00'
        }
      ],
      items: {
        type: 'object',
        properties: {
          days: {
            type: 'string',
            title: 'Días',
            enum: [
              'Lunes a Viernes',
              'Lunes a Sábado',
              'Lunes a Domingo',
              'Sábado',
              'Sábados',
              'Domingo',
              'Domingos',
              'Sábado y Domingo'
            ],
            default: 'Sábados',
          },
          startTime: {
            type: 'string',
            title: 'Hora de apertura',
            default: '09:00',
          },
          endTime: {
            type: 'string',
            title: 'Hora de cierre',
            default: '18:00',
          },
        },
      },
    },
    CTZ: {
      $id: '/properties/CTZ',
      type: 'number',
      title: 'CTZ Contador',
      default: 0,
    },
    OVTA: {
      $id: '/properties/CTZ',
      type: 'number',
      title: 'VTA Contador',
      default: 0,
    },
    OF: {
      $id: '/properties/F',
      type: 'number',
      title: 'F Contador',
      default: 0,
    },
    VTA: {
      $id: '/properties/CTZ',
      type: 'number',
      title: 'VTA Contador',
      default: 0,
    },
    F: {
      $id: '/properties/F',
      type: 'number',
      title: 'F Contador',
      default: 0,
    },
    REC: {
      $id: '/properties/CTZ',
      type: 'number',
      title: 'REC Contador',
      default: 0,
    },
    email: {
      $id: '/properties/email',
      type: 'string',
      title: 'Correo electrónico institucional',
      default: '',
      examples: ['mario@gmail.com'],
    },
    attachedFile: {
      $id: '/properties/attachedFile',
      type: 'array',
      title: 'Logo de Franquicia',
      default: '',
    },
    address: {
      $id: '/properties/address',
      type: 'object',
      title: 'Dirección',
      properties: {
        street: {
          $id: '/properties/address/properties/street',
          type: 'string',
          title: 'Calle',
          default: '',
          examples: ['Miguel Hidalgo'],
        },
        extNumber: {
          $id: '/properties/address/properties/extNumber',
          type: 'string',
          title: 'No. Exterior',
          default: '',
          examples: ['56'],
        },
        intNumber: {
          $id: '/properties/address/properties/intNumber',
          type: 'string',
          title: 'No. interior',
          default: '',
          examples: ['b'],
        },
        suburb: {
          $id: '/properties/address/properties/suburb',
          type: 'string',
          title: 'Colonia',
          default: '',
          examples: ['Niños Héroes'],
        },
        zipcode: {
          $id: '/properties/address/properties/zipcode',
          type: 'integer',
          title: 'Código Postal',
          default: 0,
          examples: [58260],
        },
        stateId: {
          $id: '/properties/address/properties/stateId',
          type: 'string',
          title: 'Estado',
          default: '',
          examples: 'example',
        },
        cityId: {
          $id: '/properties/address/properties/cityId',
          type: 'string',
          title: 'Ciudad',
          default: '',
          examples: 'example',
        },
        townId: {
          $id: '/properties/address/properties/townId',
          type: 'string',
          title: 'Localidad',
          default: '',
          examples: 'example',
        },
        coordinatesCity: {
          $id: '/properties/coordinatesCity',
          type: 'object',
          title: 'Coordenadas',
          properties: {
            lat: {
              $id: '/properties/coordinatesCity/properties/lat',
              type: 'string',
              title: 'latitud',
              default: '',
              examples: 'example',
            },
            lon: {
              $id: '/properties/coordinatesCity/properties/lon',
              type: 'string',
              title: 'longitud',
              default: '',
              examples: 'example',
            },
          },
        },
      },
    },
    socialMediaProfiles: {
      $id: '/properties/socialMediaProfiles',
      type: 'object',
      title: 'Redes Sociales',
      properties: {
        whatsapp: {
          $id: '/properties/socialMediaProfiles/properties/whatsapp',
          type: 'string',
          title: 'Whatsapp',
          default: '',
          examples: 'example',
        },
        facebook: {
          $id: '/properties/socialMediaProfiles/properties/facebook',
          type: 'string',
          title: 'Facebook',
          default: '',
          examples: 'example',
        },
        twitter: {
          $id: '/properties/socialMediaProfiles/properties/twitter',
          type: 'string',
          title: 'Twitter',
          default: '',
          examples: 'example',
        },
        instagram: {
          $id: '/properties/socialMediaProfiles/properties/instagram',
          type: 'string',
          title: 'Instagram',
          default: '',
          examples: 'example',
        },
        tiktok: {
          $id: '/properties/socialMediaProfiles/properties/tiktok',
          type: 'string',
          title: 'Tiktok',
          default: '',
          examples: 'example',
        },
      },
    },
  },
};

const uiSchema = {
  attachedFile: {
    'ui:field': 'UploadField',
  },
  businessHours: {
    items: {
      startTime: {
        'ui:widget': 'TimePickerWidget',
        'ui:options': { use24Hours: true, },
      },
      endTime: {
        'ui:widget': 'TimePickerWidget',
        'ui:options': { use24Hours: true },
      },
    },
  },
  auth: {
    'ui:widget': 'checkbox',
  },
};

const log = (type) => console.log.bind(console, type);

class FranchisesForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: props.match.params.id,
      openConfirm: false,
      openSuccess: false,
    };
  }

  componentWillMount() {
    if (this.state.id !== 'create') this.props.findById(this.state.id);
  }

  onSubmit = ({ formData }) => {
    let _this = this;
    if (
      formData.password === '' ||
      formData.password === undefined ||
      formData.password === null
    )
      delete formData.password;

    if (this.state.id !== 'create') {
      this.props.update(formData.id, formData).then(function () {
        _this.props.history.push('/admin/config/franchises');
      });
    } else {
      const slugName = formData.name
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9\s-]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-');

      formData = {
        ...formData,
        slug: slugName,
      };

      this.props.create(formData).then(function () {
        _this.props.history.push('/admin/config/franchises');
      });
    }
  };

  onDelete(confirm = false) {
    let _this = this;
    if (confirm) {
      this.props.update(this.state.id, { archived: true }).then(function () {
        _this.props.history.push('/admin/config/franchises');
      });
    } else {
      this.setState({ openConfirm: true });
    }
  }

  onBlur = (id, value) => {
    console.log('Data submitted: ', this.state.formData);
  };

  render() {
    if (!auth.can('support')) {
      uiSchema.CTZ = uiSchema.CTZ !== undefined ? uiSchema.CTZ : {};
      uiSchema.CTZ['ui:disabled'] = true;

      uiSchema.OVTA = uiSchema.OVTA !== undefined ? uiSchema.OVTA : {};
      uiSchema.OVTA['ui:disabled'] = true;

      uiSchema.OF = uiSchema.OF !== undefined ? uiSchema.OF : {};
      uiSchema.OF['ui:disabled'] = true;

      uiSchema.VTA = uiSchema.VTA !== undefined ? uiSchema.VTA : {};
      uiSchema.VTA['ui:disabled'] = true;

      uiSchema.F = uiSchema.F !== undefined ? uiSchema.F : {};
      uiSchema.F['ui:disabled'] = true;

      uiSchema.REC = uiSchema.REC !== undefined ? uiSchema.REC : {};
      uiSchema.REC['ui:disabled'] = true;
    }
    let { history, Franchises } = this.props;
    let { id, openConfirm, openSuccess } = this.state;
    return (
      <div className="main-content">
        {openConfirm && (
          <SweetAlert
            warning
            style={{ display: 'block', marginTop: '-100px' }}
            title="¿Archivar franquicia?"
            onConfirm={() => this.onDelete(true)}
            onCancel={() => this.setState({ openConfirm: false })}
            confirmBtnBsStyle="info"
            cancelBtnBsStyle="danger"
            confirmBtnText="Si, Archivar!"
            cancelBtnText="Cancelar"
            showCancel
          >
            La franquicia será archivada y ya no aparecerá en la lista activa.
          </SweetAlert>
        )}

        {openSuccess && (
          <SweetAlert
            success
            style={{ display: 'block', marginTop: '-100px' }}
            title="Listo!"
            confirmBtnBsStyle="info"
            onConfirm={() => this.setState({ openSuccess: false })}
          >
            Se ha actualizado correctamente!
          </SweetAlert>
        )}

        <Grid fluid>
          <Row>
            <Col md={12}>
              <Card
                title={<legend>Editar Franquicia</legend>}
                content={
                  <div>
                    <Form
                      schema={schema}
                      widgets={widgets}
                      fields={fields}
                      uiSchema={uiSchema}
                      onSubmit={this.onSubmit}
                      onBlur={this.onBlur}
                      formData={Franchises.formData}
                      onError={log('errors')}
                    >
                      <div>
                        <Button
                          bsStyle="success"
                          type="submit"
                          className="btn-fill"
                        >
                          Guardar
                        </Button>{' '}
                        <Button
                          bsStyle="default"
                          onClick={() =>
                            history.push('/admin/config/franchises')
                          }
                        >
                          Cancelar
                        </Button>
                        <div className="pull-right">
                          {id !== 'create' && (auth.can('support') || auth.can('matriz')) ? (
                            <Button
                              bsStyle="danger"
                              onClick={() => this.onDelete(false)}
                            >
                              Archivar
                            </Button>
                          ) : null}
                        </div>
                      </div>
                    </Form>

                    <div className="clearfix" />
                  </div>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    Franchises: state.Franchises,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(FranchisesActions, dispatch);
};

const FranchisesConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
)(FranchisesForm);

export default FranchisesConnect;



// WEBPACK FOOTER //
// ./src/views/Franchises/FranchisesForm.jsx